import { PermissionType } from 'services/permissions';
import { CompanySettings } from 'services/settings/company';

export interface User {
  id: number | null;
  version: number | null;
  createdById: number | null;
  lastModifiedById: number | null;
  dateLastModified: Date | null;
  dateCreated: Date | null;
  email: string | null;
  phoneNumber: string | null;
  phoneType: string | null;
  firstName: string | null;
  lastName: string | null;
  admin: boolean;
  defaultContact: boolean;
  deleted: boolean;
  initials: string | null;
  timezone: string | null;
  defaultLocationId: number | null;
  registered: boolean | null;
  useEmail: boolean | null;
  dateDeleted: Date | null;
  accessGroupIds: number[];
  permissions: string[];
  tenant: string | null;
  locationIdsPermitted: number[];
}

export interface ActiveUser {
  currencyCode: string | null;
  environment: string | null;
  tenant: string | null;
  user: User | null;
  userGlobalId: number | null;
  permissions: PermissionType[];
  isAdmin: boolean;
  externalAccountId: string | null;
  externalContactId: string | null;
  isExecutor: boolean;
  maxIntegrations: number | null;
}
export interface GlobalUser {
  id: number | null;
  nameFirst: string | null;
  nameLast: string | null;
  email: string | null;
  companyId: number | null;
  company: CompanySettings | null;
  name: string | null;
  tenant: string | null;
  tenantAccountType: TenantAccountType | null;
  dateLoginAttempt: string | null;
}

export interface CrmAssociation {
  id: number | null;
  crmId: string | null;
  crmType: string | null;
}
export enum PhoneTypeOptions {
  Mobile = 'Mobile',
  Office = 'Office',
  Home = 'Home',
}
export enum TenantAccountType {
  TRIAL = 'TRIAL',
  PARTNER = 'PARTNER',
  CUSTOMER = 'CUSTOMER',
  INTERNAL = 'INTERNAL',
  CONSULTANT = 'CONSULTANT',
  PREVIOUSCUSTOMER = 'PREVIOUS_CUSTOMER',
}
